import './index.scss'
import '../../assets/scripts/number.js'

// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
if (s >$(".section1").height() + $(".section2 .section-title").height()  && istrue) {
    $(".timer").each(count);
    function count(a) {
        var b = $(this);
        a = $.extend({},
        a || {},
        b.data("countToOptions") || {});
        b.countTo(a)
    };
    istrue = false;
}


$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s >$(".section1").height() + $(".section2 .section-title").height()  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };  
    
})